import { Injectable } from '@angular/core';
import { UIParticipant, UIState } from '@azavista/participants/dist/event-app/multiregistration';
import { TRANSLATION_MAP } from 'src/app/enums';
import { IField } from '../interfaces';
import { MULTI_REGISTRATION_ATTRIBUTE_NAMES } from './types';
import { SharedService } from '../shared.service';
import { TranslateService } from '@ngx-translate/core';
import { getAssignMainParticipantField, getFieldEditableByStatus } from './utils';
import { InputFieldCreatorService } from '../input-field-creator.service';
import { DomSanitizer } from '@angular/platform-browser';
import { AttributeName as GlobalAttributeName } from 'src/app/interfaces';

@Injectable({
    providedIn: 'root',
})
export class MultiRegistrationFormService {
    attributeName = MULTI_REGISTRATION_ATTRIBUTE_NAMES;

    constructor(
        private inputFieldCreatorSvc: InputFieldCreatorService,
        private sharedSvc: SharedService,
        private translateSvc: TranslateService,
        private sanitizer: DomSanitizer,
    ) {}

    createTicketField = (
        participant: Pick<UIParticipant, 'status' | 'ticket_options' | 'ticket_type_id' | 'editable'>,
        alwaysEditable?: boolean | undefined,
    ): IField => {
        const { status, ticket_options, ticket_type_id, editable } = participant;
        return {
            label: this.sharedSvc.translate(TRANSLATION_MAP.TICKET),
            name: this.attributeName.ticket_type_id,
            id: this.attributeName.ticket_type_id,
            editable: editable && (alwaysEditable ?? getFieldEditableByStatus(status)),
            schema: {
                type: ['string', 'null'],
                enum: ticket_options
                    ?.map(({ value }) => value)
                    .filter(value => ticket_type_id ? value : true)
                || [],
            },
            attributeTranslations: ticket_options?.map((ticket) => ({
                value: ticket.value,
                trans: {
                    [this.translateSvc.currentLang]: ticket.label,
                },
            })),
        } as IField;
    };

    createInputFieldElement = (
        dummyValue: null,
        field: IField,
        participant: UIParticipant,
        validateFnName = 'azavista.validateSubParticipantField'
    ) => {
        let fieldHtml = this.inputFieldCreatorSvc
            .createInputFieldBlock(field)
            .replace(
                this.inputFieldCreatorSvc['validateFnName'],
                validateFnName
            );
        if (field.id !== this.attributeName.main_participant_assigned_field_id) {
            fieldHtml = fieldHtml.replace(
                ' aza-dependency ',
                 ` aza-dependency ${GlobalAttributeName.azaInputRequired} `,
            );
        }
        return this.getSanitizedHtml(fieldHtml);
    };

    getSanitizedHtml = (fieldHtml: string) => {
        return this.sanitizer.bypassSecurityTrustHtml(fieldHtml);
    };

    createAssignMainParticipantFieldData = (
        state: UIState
    ): { field: IField; data: UIParticipant } => {
        const { main_participant, can_add_participant } = state;
        const isAssigned = !!main_participant.ticket_type_id;
        return {
            field: getAssignMainParticipantField({
                isAssigned,
                can_add_participant,
                sharedSvc: this.sharedSvc,
            }),
            data: {
                ...main_participant,
                participant_attributes: {
                    ...(main_participant.participant_attributes || {}),
                    [this.attributeName.main_participant_assigned_field_id]:
                        isAssigned,
                },
            },
        };
    };

}
